import '@va/styles/screenshot-prep.scss';
import { logVersion, setDefaultTheme } from '@va/util/helpers';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/app';

// initializeSentry();
logVersion();
setDefaultTheme();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
